import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import image11 from "../assets/images/img-k.png";
import { Modal, Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const Loan = () => {
  const [activeTopTab, setActiveTopTab] = useState("Flexible");
  const [activeBottomTab, setActiveBottomTab] = useState("Orders");
  const [opened, { open, close }] = useDisclosure(false);
  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
        <div className="max-w-7xl mx-auto px-8 py-16 font-sans">
          {/* Top Tabs */}
          <div className="flex justify-between space-x-6 border-b border-gray-200 mb-6">
            <div className="">
                {["Flexible Rate Loan", "VIP Loan", "Fixed Rate Loans"].map(
              (tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTopTab(tab.split(" ")[0])}
                  className={`pb-2 text-sm font-medium mr-16 ${
                    activeTopTab === tab.split(" ")[0]
                      ? "border-b-2 border-yellow-400 text-black"
                      : "text-gray-500"
                  }`}
                >
                  {tab}
                </button>
              )
            )}
            </div>

            <div className="ml-auto flex space-x-6 text-sm text-yellow-500 font-medium">
              <button>Loan History</button>
              <button>Loan Data</button>
            </div>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left section */}
            <div>
              <h2 className="text-yellow-500 font-bold text-lg mb-2">
                Flexible Rate Loan
              </h2>
              <h1 className="text-2xl font-bold mb-4 leading-snug">
                Borrow for Spot/Margin/Futures Trading or staking to earn high
                APY.
              </h1>
              <ul className="space-y-2 mb-4 text-sm">
                <li className="flex items-center gap-2">
                  <span>🛡</span> Repay at any time
                </li>
                <li className="flex items-center gap-2">
                  <span>⚙️</span> No transaction fee
                </li>
                <li className="flex items-center gap-2">
                  <span>🕒</span> Simple Earn (Flexible) assets can be
                  collateralized in Flexible Loan <span>↗</span>
                </li>
              </ul>
              {/* <button className="bg-yellow-400 text-white font-medium px-6 py-2 rounded hover:bg-yellow-500 transition">
                Borrow Now
              </button> */}
              <Modal onClose={close} opened={opened} title="Borrow Now"></Modal>
              <Button variant="default" onClick={open}>
                Borrow Now
              </Button>
            </div>

            {/* Right section */}
            <div className="flex flex-col space-y-4">
              {/* Fixed Rate Loans */}
              <div className="border border-yellow-100 p-4 rounded-md flex justify-between items-center bg-yellow-50">
                <div>
                  <h3 className="font-semibold text-sm mb-1">
                    Fixed Rate Loans
                  </h3>
                  <p className="text-sm text-gray-600">
                    Create a borrow request or supply order with your preferred
                    amount and interest rate.
                  </p>
                  <button className="text-yellow-500 font-medium text-sm mt-2">
                    Explore Now
                  </button>
                </div>
                <img
                  src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/000000/exchange-money.png"
                  alt="Fixed Loan"
                  className="w-12 h-12"
                />
              </div>

              {/* VIP Loan */}
              <div className="border border-yellow-100 p-4 rounded-md flex justify-between items-center bg-yellow-50">
                <div>
                  <h3 className="font-semibold text-sm mb-1">VIP Loan</h3>
                  <p className="text-sm text-gray-600">
                    Institutional Level Loan Services for VIP users
                  </p>
                  <button className="text-yellow-500 font-medium text-sm mt-2">
                    Explore Now
                  </button>
                </div>
                <img
                  src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/000000/bank-building.png"
                  alt="VIP Loan"
                  className="w-12 h-12"
                />
              </div>
            </div>
          </div>

          {/* Bottom Tabs */}
          <div className="flex justify-between items-center mt-12">
            <div className="flex space-x-6 text-lg font-semibold">
              <button
                onClick={() => setActiveBottomTab("Orders")}
                className={`pb-1 ${
                  activeBottomTab === "Orders"
                    ? "border-b-2 border-yellow-400 text-black"
                    : "text-gray-400"
                }`}
              >
                Ongoing Orders (0)
              </button>
              <button
                onClick={() => setActiveBottomTab("Overview")}
                className={`pb-1 ${
                  activeBottomTab === "Overview"
                    ? "border-b-2 border-yellow-400 text-black"
                    : "text-gray-400"
                }`}
              >
                Asset Overview
              </button>
            </div>
            <div className="text-sm text-gray-600">Sort by LTV ⬍</div>
          </div>

          {/* No Records Section */}
          <div className="flex flex-col items-center justify-center h-48 mt-6 text-sm text-gray-500">
            <img
              src={image11}
              alt="No Records"
              className="w-10 h-10 mb-2 opacity-60"
            />
            No Records Found.
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Loan;
